import type { IMenuBridge } from '@erp/native/interfaces';

export function createWebMenu(): IMenuBridge {
  return {
    onItem() {
      // Browsers have no native menu bar — nothing to subscribe to.
      return () => {};
    },
  };
}
